import * as actions from './ranking.actions'

const initialState = {
  search: null,
  filter: null,
  chatTarget: null,
  federation: null,
}

const actionsMap = {
  [actions.CHANGE_FILTER]: (state, action) => {
    const filter = action.data
    return {
      ...state,
      filter: filter,
    }
  },
  [actions.SEARCH_USER]: (state, action) => {
    const search = action.data

    return {
      ...state,
      search: search,
    }
  },
  [actions.SELECT_FEDERATION]: (state, action) => {
    const federation = action.data

    return {
      ...state,
      federation,
    }
  },
  [actions.SET_CHAT_TARGET]: (state, action) => {
    const target = action.data

    return {
      ...state,
      chatTarget: target,
    }
  },
}

/* eslint require-jsdoc: 0 */
export default function reducer(state = initialState, action = {}) {
  const fn = actionsMap[action.type]
  return fn ? fn(state, action) : state
}
